import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../global/button/Button'
import { FormatCSVIcon } from '../../../icons/FormatCSVIcon'
import { FormatExcelIcon } from '../../../icons/FormatExcelIcon'
import { FormatPDFIcon } from '../../../icons/FormatPDFIcon'
import { RadioModal } from './RadioModal/RadioModal'
import { ModalProps } from './types'

interface ExportModalProps extends Omit<ModalProps, 'size'> {
  fileName?: string
  csvData: object[]
  onClose(): void
  onExportToPdf(): void
  onExportToCSV(): void
  onExportToExcel(): void
}

export const ExportModal: React.FC<ExportModalProps> = (props) => {
  const { onClose, onExportToCSV, onExportToPdf, onExportToExcel } = props
  const { t } = useTranslation()

  const ExcelButton = (): React.ReactNode => (
    <RadioModal.IconOption
      label={t('Export as Excel')}
      icon={<FormatExcelIcon />}
      onClick={onExportToExcel}
    />
  )

  const PDFButton = (): React.ReactNode => (
    <RadioModal.IconOption
      label={t('Export as PDF')}
      icon={<FormatPDFIcon />}
      onClick={onExportToPdf}
    />
  )

  const CSVButton = (): React.ReactNode => (
    <RadioModal.IconOption
      label={t('Export as CSV')}
      icon={<FormatCSVIcon />}
      onClick={onExportToCSV}
    />
  )

  return (
    <RadioModal
      title={t('Export')}
      renderFooter={({ onClose }) => [
        <Button appearance='primary' onClick={onClose}>
          {t('Cancel')}
        </Button>,
      ]}
      options={[<ExcelButton />, <PDFButton />, <CSVButton />]}
      onClose={onClose}
    />
  )
}
